/*!
=========================================================
* Material Dashboard PRO React - v1.9.0
=========================================================
* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client"; // New import for React 18
import { createBrowserHistory } from "history";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { loadReCaptcha } from "react-recaptcha-google";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import TermsAndConditionsPage from "views/Pages/TermsAndConditionsPage";


import "assets/scss/material-dashboard-pro-react.scss?v=1.9.0";

import LoginPage from "views/Pages/LoginPage";
import PublishedForm from "views/Dashboard/Form/PublishedForm";
import {Amplify}  from "aws-amplify"

Amplify.configure({
  Auth: {
    userPoolId: "us-west-2_C6xJ1UnEm",
    userPoolWebClientId: "f4b59vhc8l6jg4n2mlveeqsdc",
    loginWith: { email: true, username: false },
  },
});

loadReCaptcha();

const hist = createBrowserHistory();
const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement); // Use createRoot instead of ReactDOM.render

  root.render(
    <Router history={hist}>
      <Switch>
        <Route path="/published_form/:formID" component={PublishedForm} />
        <Route path="/terms" component={TermsAndConditionsPage} />
        <Route path="/auth" component={AuthLayout} />
        <Route path="/create" component={AdminLayout} />
        <Redirect from="*" to="/create/landing-page" />
      </Switch>
    </Router>
  );
}
